@if (loading | async) {
    <div class="spinner-container d-flex justify-content-center align-items-center">
        <mat-spinner></mat-spinner>
    </div>
} @else {
    <div class="container mb-5">
        <div class="w-fit">
            <app-back-button component="Claims" (click)="onBackClick()"></app-back-button>
        </div>
        <div class="d-flex align-items-center mt-3">
            <div class="col-lg-4 col-12">
                <h1>File a Claim</h1>
            </div>
        </div>
        <div class="row mt-3 mb-4 reservation-information-container">
            <app-reservation-detail-card [reservation]="reservation"></app-reservation-detail-card>
        </div>
        <div class="row mt-5 mb-5">
            <mat-accordion>
                <app-what-happened-step 
                    [whatHappenedForm]="whatHappenedForm" 
                    [injuryAddressForm]="injuryAddressForm"
                    [governmentDepartmentForm]="governmentDepartmentForm" 
                    [reservation]="reservation"
                    *ngIf="reservation" 
                    [countries]="countries" 
                    [states]="states">
                </app-what-happened-step>
                <app-payment-information-step *ngIf="shouldShowPaymentInfoStep()" 
                    [form]="paymentInformationForm" 
                    [countries]="countries"
                    [states]="states" 
                    [organization]="organization"
                    [reservation]="reservation"
                    [sendCheckToAddress]="send_check_to_address"
                >
                </app-payment-information-step>
                <app-supporting-documents-step 
                    [lossForm]="lossForm"
                    [(supportingDocumentSections)]="supportingDocumentSections"
                    [existingSupportingDocuments$]="existingSupportingDocuments$"
                    [invalidSupportingDocumentNames]="invalidSupportingDocumentNames">
                </app-supporting-documents-step>
            </mat-accordion>
        </div>
        <div class="mt-2 mb-2 d-flex justify-content-end">
            <button mat-raised-button
                class="save-button" (click)="submitClaim(false, true)"
                [disabled]="!canSaveDraft()">
                <mat-icon>save</mat-icon>
                Save Draft
            </button>
            <button 
                mat-raised-button 
                class="action-button submit-claim-button"
                [disabled]="!submitClaimEnabled" 
                (click)="submitClaim(true, false)">
                <mat-icon>check</mat-icon>
                Submit Claim
            </button>
        </div>
        <mat-action-row class="mt-4">
            <div class="col">
                <div *ngIf="submitClaimEnabled" class="d-flex justify-content-end text-muted" style="margin-right: 3;">
                    <span class="required-input">**</span>&nbsp;- Damage Date, Description{{ injuryLossFormInvalid ? ', Injury Address,' : '' }} and Amount required before draft can be saved.
                </div>
                <div *ngIf="!canCreateClaim()" class="d-flex justify-content-end text-muted" style="margin-right: 3;">
                    <span class="required-input">*</span>&nbsp;- Damage Date, Description, Amount, Payment Information{{ injuryLossFormInvalid ? ', Injury Address,' : '' }} and Supporting Documents required before claim can be submitted.
                </div>
            </div>
        </mat-action-row>
    </div>
}

@if(claimDocumentsWaitingForUpload.length > 0) {
    <div class="overlay">
        <div class="overlay-content gap-5">
            <h2>Uploading Documents...</h2>
            <mat-spinner></mat-spinner>
            <p class="fs-4">{{ claimDocumentsWaitingForUpload.length }} documents left to upload</p>
        </div>
    </div>
}